import React, { cloneElement } from 'react';
import { LoadingSpinner, AlertBox } from 'legacy-packages/ft-cb';
import { withAssignmentPreviewScoringRubric } from 'legacy-src/utility/withAssignmentPreviewScoringRubric';
import './ScoringByRubricContainer.scss';

/**
 * Provides scores by rubric props
 * */
const StudentResponsesContainer = (props) => {
  const {
    studentSessionReviewSignedRequest,
    scoringRubricSignedRequest,
    responseAnalysisSignedRequest,
    scoringRubricResponseAnalysisSignedRequest,
    scoringRubricResponses,
    params,
    loading,
    children,
    router,
    routes,
    location,
    assignment,
    progressPerStudent,
    error,
    showHeader,
    canSave,
    isFinalExam,
    userData: {
      me: { initId, firstName, lastName },
    },
    isStudent,
    subjectData,
    featureFlags,
    onClose = () => {},
  } = props;
  if (loading) {
    return <LoadingSpinner data-test-learnosity-loading />;
  }

  const { questions } = assignment || {};

  const scoringStudent = {
    id: initId,
    firstName,
    lastName,
  };

  if (error) {
    return (
      <div className="page_wrapper">
        <AlertBox color="red" icon="circle_warn">
          {error}
        </AlertBox>
      </div>
    );
  }

  // getting the child this way because for some reason, the children prop refers to the parent component for students results pages
  const currentRoute = routes[routes.length - 1];
  const { component: ChildComponent } = currentRoute;

  const childProps = {
    studentSessionReviewSignedRequest,
    progressPerStudent,
    scoringRubricSignedRequest,
    responseAnalysisSignedRequest,
    scoringRubricResponseAnalysisSignedRequest,
    questions,
    scoringRubricResponses,
    scoringStudent,
    assignment,
    params,
    isFinalExam,
    pushPathname: router.push,
    location,
    showHeader,
    canSave,
    onClose,
    showActionButtons: false,
    isStudent,
    subjectData,
    featureFlags,
    newMobileUIFlag: false,
    charmUpdateFlag: featureFlags.charm_update,
    preApCharmUpdateFlag: featureFlags.charm_update_preap,
    isApSubject: !subjectData.isPreApSubject,
    responsesPage: true,
  };

  return (
    <div className="ScoringByRubric page_wrapper">
      {children ? (
        currentRoute.name === 'StudentRubricsQuestions' ? (
          <ChildComponent {...childProps} />
        ) : (
          cloneElement(children, childProps)
        )
      ) : null}
    </div>
  );
};

StudentResponsesContainer.defaultProps = {
  showHeader: true,
  canSave: true,
};

export default withAssignmentPreviewScoringRubric(StudentResponsesContainer);
